export default {
  list: [],
  form: {},
  requestStatus: "",
  equipes: []
};
